var render = function render(){var _vm=this,_c=_vm._self._c;return _c('iframe',{staticStyle:{"border":"none"},attrs:{"src":_vm.url,"width":"1618","height":"800"}})
}
var staticRenderFns = []

export { render, staticRenderFns }